export const CONFIG_TYPE = 'JanusProductionData'
